import LogicaAPI from "./logicaapi";
const CHAT_MESSAGE_TYPE = "message";
class Chat extends LogicaAPI {
  /**
   * ルーム情報取得
   * /api/v1/metas/{meta_id}/meta_rooms
   */
  async getRoomToken(roomId) {
    return this.get(`/api/v1/watchparty/rooms/${roomId}/token`);
  }
  async getUserToken(roomId, userId) {
    return this.get(`/api/v1/watchparty/rooms/${roomId}/users/token?watchparty_user_id=${userId}`);
  }

  /**
   * ユーザー作成
   * /api/v1/watchparty/rooms/{room_id}/users
   */
  async createUser(roomId, metaId) {
    const params = {
      meta_id: metaId
    };
    return this.post(`api/v1/watchparty/rooms/${roomId}/users`, {
      body: params
    });
  }
  async postMessage(roomId, userId, message, refId, displayName, token) {
    const params = {
      type: CHAT_MESSAGE_TYPE,
      data: {
        message: message,
        sender: {
          refId: refId,
          id: userId,
          displayName: displayName
        }
      },
      token: token
    };
    return this.post(`api/v1/watchparty/rooms/${roomId}/messages`, {
      body: params
    });
  }
  async deleteMessage(roomId, messageId) {
    return this.put(`api/v1/watchparty/rooms/${roomId}/messages/${messageId}/delete`);
  }
  async reportMessage(roomId, messageId, reason) {
    const params = {
      reason: reason
    };
    return this.put(`api/v1/watchparty/rooms/${roomId}/messages/${messageId}/report`, {
      body: params
    });
  }
}
export default Chat;